import palette from '../palette';

export default {
  indicator: {
    width: '148px !important',
    backgroundColor: palette.secondary.main,
    height: 3,
  },
};
